import { orderBy } from 'lodash';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { useConfig } from '../../config/config.context';
import { useDesignConfig } from '../../config/design.context';
import { ProvideCurrentScreen } from '../../core/hooks/useCurrentScreen.hook';
import UrlStateModalRouter from '../../modals/UrlStateModalRouter';
import DefaultRouter from '../Routers/DefaultRouter';
import layoutProps from '../layoutProps';
import { componentRouters, routeComponents } from './DefaultRoutes';
import PageLayout from './PageLayout';

const LegacyRoutes = () => {
  const { homeBackground, mobileHomeBackground } = useDesignConfig();
  const { menu, menus } = useConfig();
  return (
    <PageLayout
      background={homeBackground}
      mobileBackground={mobileHomeBackground}
      menu={menu}
      menus={menus}
    >
      <DefaultRouter />
    </PageLayout>
  );
};

const DefaultLayout = () => {
  const { screens } = useConfig();
  // Order to register long paths (ex : /xxx/:slug) first
  const routerScreens = orderBy(
    Object.keys(screens).filter((screenId) => screens[screenId].path),
    (screenId) => screens[screenId].path.length,
    'desc',
  );
  return (
    <>
      <Switch>
        {routerScreens.map((screenId) => {
          const screen = screens[screenId];
          const Component = routeComponents[screen.type];
          const Router = componentRouters[screen.type];
          if (!Component && !Router) return null;

          if (Router) return <Router key={screenId} {...screen} pageId={screenId} />;

          return (
            <Route
              key={screenId}
              path={screen.path}
              exact
              render={(props) => {
                if (screen.forceRedirectTo) {
                  // TODO: rename to `redirectTo` after OVH
                  return <Redirect redirectTo to={screen.forceRedirectTo} />;
                }
                return (
                  <ProvideCurrentScreen screenId={screenId} screen={screen}>
                    <Component {...props} {...screen} pageId={screenId} />
                  </ProvideCurrentScreen>
                );
              }}
            />
          );
        })}
        <Route component={LegacyRoutes} />
      </Switch>
      <UrlStateModalRouter />
    </>
  );
};

DefaultLayout.propTypes = layoutProps;

export default DefaultLayout;
